module.exports = __webpack_public_path__ + "img/flex.1f2833b7.webp";